import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const SortControls = ({ sortBy, sortOrder, onSortChange }) => {
  const theme = useTheme();

  // Handle sort by change
  const handleSortByChange = (event) => {
    onSortChange(event.target.value, sortOrder);
  };

  // Handle sort order toggle
  const handleSortOrderToggle = () => {
    onSortChange(sortBy, sortOrder === "asc" ? "desc" : "asc");
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {/* Sort Controls */}
      <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
        <FormControl size="small" sx={{ minWidth: 120, mr: 1 }}>
          <InputLabel id="sort-by-label">Sort By</InputLabel>
          <Select
            labelId="sort-by-label"
            id="sort-by"
            value={sortBy}
            label="Sort By"
            onChange={handleSortByChange}
          >
            <MenuItem value="name">Name</MenuItem>

            <MenuItem value="position">Position</MenuItem>
            <MenuItem value="height">Height</MenuItem>
            <MenuItem value="weight">Weight</MenuItem>
            <MenuItem value="gpa">GPA</MenuItem>
          </Select>
        </FormControl>

        <Tooltip
          title={`Sort ${sortOrder === "asc" ? "Descending" : "Ascending"}`}
        >
          <IconButton
            size="small"
            onClick={handleSortOrderToggle}
            sx={{
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 1,
            }}
          >
            {sortOrder === "asc" ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default SortControls;
